<template>
  <v-list-item-subtitle>
    <v-container fluid>
      <v-layout wrap align-center hidden-md-and-up>
        <v-flex xs6>
          <p id="login">Login:</p>
          <p class="creds-style font-weight-bold">{{ environment.ApplicationLogin }}</p>
        </v-flex>
        <v-flex xs6>
          <p>Password:</p>
          <p>
            <span class="creds-style font-weight-bold" :id="'password-' + environment.Id" @click="copyPassword">{{ password }}</span>
          <v-icon right small class="copy-icon" @click="togglePassword" :class="hiddenPassword ? 'far fa-eye' : 'fas fa-eye-slash'"></v-icon>
          </p>
        </v-flex>
      </v-layout>
    </v-container>
  </v-list-item-subtitle>
</template>

<script>
export default {
  data() {
    return {
      hiddenPassword: true,
      hashedPassword: '********'
    }
  },
  props: [ 'environment', 'password' ],
  methods: {
    togglePassword() {
      this.$emit('togglePassword');
    },
    copyPassword() {
      this.$emit('copyPassword');
    }
  }
}
</script>